import { Component, OnInit, HostBinding, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { KeycloakService, KeycloakEventType } from 'keycloak-angular';
import { Router } from '@angular/router';
import { KeycloakInitializerService } from 'src/app/services/keycloakInitializer.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'login-buttons',
    templateUrl: './login-buttons.component.html',
    styleUrls: ['./login-buttons.component.scss']
})
export class LoginButtonsComponent implements OnInit {
    protected isLoggedIn: boolean = false;
    protected keycloakInitialized: boolean = false;
    private destroy$: Subject<void> = new Subject();

    @HostBinding('class') class: string;

    constructor(protected authService: AuthService,
        protected keycloakAngular: KeycloakService,
        private router: Router,
        private keycloakInitializer: KeycloakInitializerService) { }

    ngOnInit() {
        if (this.keycloakInitializer.isInitialized) {
            this.checkLoggedIn();
        } else {
            this.keycloakInitializer.initialized
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.keycloakInitialized = true;
                    this.checkLoggedIn();
                })
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private async checkLoggedIn() {
        this.isLoggedIn = await this.authService.isLoggedIn();
    }

    login() {
        this.authService.logIn();
    }

    register() {
        this.authService.register();
    }

    logout() {
        this.authService.logOut();
    }

    goToMyAccount() {
        this.router.navigate(['/my-account']);
    }

    goToControlPanel() {
        const lang: string = window.location.href.replace('https://', '').replace('http://', '').split('/')[1];
        window.location.href = environment.panel_url + '/' + lang;
    }
}
